<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Physical Verification Report</h5>
  </div>
<div id="mainContent" class="container">
    <div class="modal-body">
      <div class="row">
            <div class="col-md-6">
              <div class="row">  
                  <div class="col-md-2">    
                 <label class="col-form-label">Type</label>
                </div>
                 <div class="col-md-6">
              <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectType"
                (change)="selectTypeClick()">
                <option value="Software">Software</option>
                <option value="Hardware">Hardware</option>
              </select>
            </div>
        </div>
     </div> 
     <div class="col-sm-6" >
      <div class="row">
        <label class="col-sm-2 col-form-label">Branch</label>
        <div class="col-sm-6">
          <select
            class="form-control form-control-xs"
            id="BranchName"
            name="BranchName"
            [(ngModel)]="selectBranch"
          >
            <option value="null">Select Branch</option>
            <option *ngFor="let branchName of branchList" [ngValue]="branchName">
              {{ branchName.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-2">
            <label> Date </label>
          </div>
  
          <div class="col-sm-6">
            <div class="input-group">
              <input
                class="form-control form-control-xs"
                placeholder="dd/mm/yyyy"
                name="fromDate"
                ngbDatepicker
                #fromDate="ngbDatepicker"
                [placement]="'bottom'"
                [maxDate]="currentDate"
                [(ngModel)]="selectDate"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-theme calendar"
                  (click)="fromDate.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="col-md-2 ">
                <button
                  type="button"
                  class="btn btn-sm btn-block btn-outline-theme"
                  (click)="onViewReport()">
                  View Report
                </button>
        </div>

         <div class="col-md-2">
                <button
                  type="button"
                  class="btn btn-sm btn-block btn-outline-theme"
                  (click)="onExportToExcelReport()"
                  *ngIf="showExcelButton"
                >
                  Export To Excel
                </button>
              </div>
    </div>
</div>
</div>

<div class="container" id="mainContent">
<div class="mt-4" id="contentToConvert" *ngIf="reportList.length>0">
    <div class="row justify-content-center text-center mt-4" style="padding-top: 10px;">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>
    
    <div class="row col-md-12 mt-2">
    <table *ngIf="selectType=='Software'" class="table table-bordered table-sm table-striped">
       <thead>
           <th>Service Tag</th>
           <th>Name</th>
           <th>Type</th>
           <th>Hardware Name</th>
           <th>Hardware Service Tag No.</th>
           <th>Date Of Purchase</th>
           <th>Product Key</th>
           <th>Expiry Date</th>
           <th>Status</th>
       </thead>
      <tbody *ngFor="let softwareData of reportList">
          <td>{{softwareData.software.serviceTagNumber}}</td>
          <td>{{softwareData.software.assetName}}</td>
          <td>{{softwareData.software.subType.name}}</td>
          <td>{{softwareData.hardware!=null?softwareData.hardware.assetName:'NA'}}</td>
          <td>{{softwareData.hardware!=null?softwareData.hardware.serviceTagNumber:'NA'}}</td>
          <td>{{softwareData.software.dateOfPurchase}}</td>
          <td>{{softwareData.software.productKey}}</td>
          <td>{{softwareData.software.expiryDate!=null?softwareData.software.expiryDate:'NA'}}</td>
          <td>{{getSoftwareStatus(softwareData)}}</td>
      </tbody>
    </table>  
</div>

    <div class="row col-md-12 mt-2">
    <table *ngIf="selectType=='Hardware'" class="table table-bordered table-sm table-striped">
        <thead>
            <th>Service Tag</th>
            <th>Type</th>
            <th>Employee Name</th>
            <th>Date Of Purchase</th>
            <th>Make</th>
            <th>Model No.</th>
            <th>Expiry Date</th>
            <th>Status</th>
        </thead>
       <tbody *ngFor="let hardwareData of reportList">
        <td>{{hardwareData.asset.serviceTagNumber}}</td>
        <td>{{hardwareData.asset.subType.name}}</td>
        <td>{{getEmployeeName(hardwareData)}}</td>
        <td>{{hardwareData.asset.dateOfPurchase!=null?hardwareData.asset.dateOfPurchase:'NA'}}</td>
        <td>{{hardwareData.asset.make!=null?hardwareData.asset.make:'NA'}}</td>
        <td>{{hardwareData.asset.modelNo!=null?hardwareData.asset.modelNo:'NA'}}</td>
        <td>{{hardwareData.asset.dateOfRetirementOfAsset!=null?hardwareData.asset.dateOfRetirementOfAsset:'NA'}}</td>
        <td>{{getHardwareStatus(hardwareData)}}</td>
      </tbody>
     </table> 
</div>
</div>
</div>
</div>
